<template>
  <Accordion>
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </Accordion>
</template>

<script setup lang="ts">
import type { AccordionEmits, AccordionProps } from "primevue";

import { Accordion } from "primevue";

import "./pAccordion.css";
import "./pChip.css";
import "./pInputText.css";

defineProps</* @vue-ignore */ AccordionProps>();
defineEmits</* @vue-ignore */ AccordionEmits>();
</script>
